import { FETCH_CMS_ADS_REQUEST, FETCH_CMS_ADS_SUCCESS, FETCH_CMS_ADS_FAILURE } from "../../actions/cmsAdsAction";

const initialState = {
    adsBanner: {
      pdp: {
        loading: false,
        adsData: null,
        error: null,
      },
      cart: {
        loading: false,
        adsData: null,
        error: null,
      },
      myaccount: {
        loading: false,
        adsData: null,
        error: null,
      },
      orderlisting: {
        loading: false,
        adsData: null,
        error: null,
      },
      thankyou: {
        loading: false,
        adsData: null,
        error: null,
      },
    },
  };
  
  const cmsAdsReducer = (state = initialState, action) => {
    switch (action.type) {
      case "FETCH_CMS_ADS_REQUEST":
        return {
          ...state,
          adsBanner: {
            ...state.adsBanner,
            [action.payload.page]: {
              ...state.adsBanner[action.payload.page],
              loading: true,
              error: null,
            },
          },
        };
  
      case "FETCH_CMS_ADS_SUCCESS":
        return {
          ...state,
          adsBanner: {
            ...state.adsBanner,
            [action.payload.page]: {
              ...state.adsBanner[action.payload.page],
              loading: false,
              adsData: action.payload.adsData,
              error: null,
            },
          },
        };
  
      case "FETCH_CMS_ADS_FAILURE":
        return {
          ...state,
          adsBanner: {
            ...state.adsBanner,
            [action.payload.page]: {
              ...state.adsBanner[action.payload.page],
              loading: false,
              error: action.payload.error,
            },
          },
        };
  
      default:
        return state;
    }
  };
  
  export default cmsAdsReducer;  